import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"

const Advantage = () => {
    return (
      <Block className="advantage-inner">
        <Element type="h2">{"İstediğiniz yerden"}<br />{"Mobil'den kolayca"}<br />
          <Element type="strong">{"Akbanklı olun!"}</Element>
        </Element>
        <Element type="p">
          {"Akbank Mobil'den 'Akbanklı Olmak İstiyorum' adımlarını takip ederek 08.00 - 01.00 saatleri arasında şubeye gitmeden dakikalar içinde müşterimiz olabilirsiniz."}
        </Element>
        <Element type="p" className="form-text-strong">
          {"Mobil’den Akbanklı olmanıza özel avantaj ve kampanyalardan hemen faydalanabilirsiniz!"}
        </Element>
        <Image path={"./img/mobiluygulama/kolay-adres.png"} className="landing-header-img" />
      </Block>
    )
}

export default Advantage
